import {
  NodeType,
  ResolvedNodeDefinitions
} from 'Automations/nodeDefinitions/types'
import {
  IntermediateNodeWithConditionalsAndOutputs,
  IntermediateNodeWithConditionalsInputsAndOutputs
} from '../../presentationToConductorWorkflow.types'

export const applyInputMapping =
  (definitions: ResolvedNodeDefinitions) =>
  (
    intermediateNodes: IntermediateNodeWithConditionalsAndOutputs[],
    upstreamNodes: IntermediateNodeWithConditionalsAndOutputs[] = []
  ): IntermediateNodeWithConditionalsInputsAndOutputs[] =>
    intermediateNodes.map((node, nodeIndex) => {
      if (!node.node.type) throw new Error('nodeType is undefined')

      const definition = definitions[node.node.type as NodeType]

      const upstreamNodesForThisNode = [
        ...upstreamNodes,
        ...intermediateNodes.slice(0, nodeIndex)
      ]

      return {
        ...node,
        inputs:
          definition.inputMapping?.({
            upstreamNodes: upstreamNodesForThisNode,
            config: node.node.data
          }) ?? {},
        branches: node.branches.map(branch =>
          applyInputMapping(definitions)(branch, [
            ...upstreamNodesForThisNode,
            node
          ])
        ),
        groupContinuations: node.groupContinuations
          ? Object.fromEntries(
              Object.entries(node.groupContinuations).map(([k, v]) => [
                k,
                applyInputMapping(definitions)(v, [
                  ...upstreamNodesForThisNode,
                  node
                ])
              ])
            )
          : undefined
      }
    })
